import { StyleRules, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRules = {
  container: {
    display: "flex",
    justifyContent: "center"
  }
};

export const BaseCardContainer: React.FC<WithStyles<typeof styles>> = ({ children, classes }) => (
  <div className={classes.container}>{children}</div>
);

export const CardContainer = withStyles(styles)(BaseCardContainer);
